import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import ContentWrapper from "../../../common/modules/wrappers/ContentWrapper";
import DisplayWrapper from "../../../common/modules/wrappers/DisplayWrapper";
import { appendSearchParamsToURL } from "../../../common/utils/utils";
import type { UUID } from "../../../typings/global";
import { requests } from "../api";
import { AgentTreeFilterView } from "../components/views/tree/AgentTreeFilterView";
import { AgentTreeView } from "../components/views/tree/AgentTreeView";
import { deleteStateAgentTreeAction, getAgentTreeActions, selectAgentTree } from "../ducks";
import { AgentTreeFilterRequest } from "../types";

export const AgentTreeContainer = () => {
  const navigate = useNavigate();
  const [urlParams] = useSearchParams();

  const agentTree = useSelector(selectAgentTree);

  const dispatch = useDispatch();
  const actions = useMemo(
    () =>
      bindActionCreators(
        { getAgentTree: getAgentTreeActions.request, deleteStateAgentTree: deleteStateAgentTreeAction },
        dispatch
      ),
    [dispatch]
  );

  useEffect(() => {
    actions.getAgentTree({
      rootAgentId: urlParams.get("rootAgentId") as UUID,
      includeDeactivated: urlParams.get("includeDeactivated") === "true",
      includeRepresentatives: urlParams.get("includeRepresentatives") === "true"
    });

    return () => {
      actions.deleteStateAgentTree();
    };
  }, []);

  const handleFilterSubmit = (filter: AgentTreeFilterRequest): void => {
    navigate(
      appendSearchParamsToURL({
        ...filter,
        includeDeactivated: filter.includeDeactivated ?? undefined,
        includeRepresentatives: filter.includeRepresentatives ?? undefined
      }),
      { replace: true }
    );
    actions.getAgentTree(filter);
  };

  return (
    <ContentWrapper>
      <DisplayWrapper itemLoaded={!!agentTree} notFoundCheckRequest={requests.GET_AGENT_TREE}>
        {agentTree ? (
          <>
            <AgentTreeFilterView filter={agentTree} onFilterSubmit={handleFilterSubmit} />
            <AgentTreeView agentTree={agentTree} />
          </>
        ) : undefined}
      </DisplayWrapper>
    </ContentWrapper>
  );
};
